import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import './search.scss';
import debounce from '../../utils/debounce/Debounce';

interface SearchProps {
  // eslint-disable-next-line no-unused-vars
  setSearchQuery: (val: string) => void;
  placeholderValue?: string;
  leftIconImg?: boolean;
  rightIconImg?: boolean;
  onPressEnter?: () => void;
  fullWidth?: boolean;
  style?: React.CSSProperties;
}

const Search = (props: SearchProps) => {
  const {
    setSearchQuery,
    placeholderValue,
    leftIconImg,
    rightIconImg,
    onPressEnter,
    fullWidth,
    style,
  } = props;

  const onSearchChange = (value: string) => {
    setSearchQuery(value);
  };

  const onChange = debounce((e: any) => {
    onSearchChange(e.target.value);
  }, 500);

  const onPress = () => {
    if (onPressEnter) {
      onPressEnter();
    }
  };

  return (
    <div
      className={
        fullWidth ? 'searchBoxContainer searchBoxContainer--fullWidth' : 'searchBoxContainer'
      }
      style={fullWidth ? { width: '100%' } : undefined}
    >
      <Input
        prefix={leftIconImg ? <SearchOutlined className="searchOutline" /> : null}
        suffix={rightIconImg ? <SearchOutlined /> : null}
        onPressEnter={onPress}
        className="searchBox"
        onChange={onChange}
        placeholder={placeholderValue ? `Search by ${placeholderValue}` : 'Search...'}
        style={{
          ...(fullWidth ? { width: '100%' } : {}),
          ...style,
        }}
      />
    </div>
  );
};

Search.defaultProps = {
  leftIconImg: false,
  rightIconImg: false,
};

export default Search;
